import * as Sentry from '@sentry/react';

import sentryHelper from './helper';

sentryHelper.setLibrary<typeof Sentry>(Sentry);

export default sentryHelper;
